import { render, staticRenderFns } from "./page-header.html?vue&type=template&id=481ccee0&"
import script from "./page-header.ts?vue&type=script&lang=ts&"
export * from "./page-header.ts?vue&type=script&lang=ts&"
import style0 from "./page-header.styl?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports